import { createRouter, createWebHashHistory } from 'vue-router'
import TimeAttendance from '../components/TimeAttendance.vue'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: () => import('../components/WelcomePage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/app',
    name: 'Home',
    component: () => import('../components/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('../components/PasswordReset.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/attendance',
    name: 'TimeAttendance',
    component: TimeAttendance,
    meta: { requiresAuth: true }
  },
  {
    path: '/leave',
    name: 'LeaveManagement',
    component: () => import('../components/LeaveManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/recruitment',
    name: 'Recruitment',
    component: () => import('../components/Recruitment.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'EmployeeProfile',
    component: () => import('../components/EmployeeProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../components/ChangePassword.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../components/Notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/ot-management',
    name: 'OtManagement',
    component: () => import('../components/EnhancedOtManagement.vue'),
    meta: { requiresAuth: true }
  },
  // Legacy KPI routes (keeping for backward compatibility)
  {
    path: '/kpi/test',
    name: 'KpiTest',
    component: () => import('../components/KpiTest.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/dashboard',
    name: 'KpiDashboard',
    component: () => import('../components/KpiDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/list',
    name: 'KpiList',
    component: () => import('../components/KpiMobile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/create',
    name: 'KpiCreate',
    component: () => import('../components/KpiForm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/:id/edit',
    name: 'KpiEdit',
    component: () => import('../components/KpiForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/:id',
    name: 'KpiDetails',
    component: () => import('../components/KpiDetails.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/measurement',
    name: 'KpiMeasurement',
    component: () => import('../components/KpiMeasurement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/:id/measurement/add',
    name: 'KpiMeasurementAdd',
    component: () => import('../components/KpiMeasurement.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/kpi/:id/target/add',
    name: 'KpiTargetAdd',
    component: () => import('../components/KpiTargetForm.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/storage-test',
    name: 'StorageTest',
    component: () => import('../views/StorageTest.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/translation-test',
    name: 'TranslationTest',
    component: () => import('../components/TestTranslation.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/document-upload-test',
    name: 'DocumentUploadTest',
    component: () => import('../components/DocumentUploadTest.vue'),
    meta: { requiresAuth: false }
  },
  // Catch-all route
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../components/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('authToken')
  
  if (to.path === '/') {
    // Welcome page - always accessible
    next()
  } else if (to.meta.requiresAuth && !isAuthenticated) {
    // Redirect to login if trying to access protected route without authentication
    next('/#/login')
  } else if (to.path === '/login' && isAuthenticated) {
    // Redirect to app if already authenticated and trying to access login
    next('/#/app')
  } else {
    // Allow navigation
    next()
  }
})

export default router 